import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useClampingStepStore } from '@/store/clampingStep';
import { useComputeWizardStore } from '@/store/computeWizard';
import { useFrictionStepStore } from '@/store/frictionStep';
import { useQualityStepStore } from '@/store/qualityStep';
import { useSizeStepStore } from '@/store/sizeStep';
import { useSurfaceStepStore } from '@/store/surfaceStep';
import SplashScreen from '@/components/SplashScreen.vue';
import useLangSettings from '@/composables/useLangSettings';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const { initAppLanguage } = useLangSettings();

const preloadStore = async () => {
  useClampingStepStore();
  useComputeWizardStore();
  useFrictionStepStore();
  useQualityStepStore();
  useSizeStepStore();
  useSurfaceStepStore();
};

onMounted(() => {
  preloadStore();
  initAppLanguage();
});

const shouldDisplaySplashscreen = ref<boolean>(true);

const hideSplashscreen = () => {
  shouldDisplaySplashscreen.value = false;
};

watch(route, () => {
  const ionContents = [...document.querySelectorAll('ion-content')];

  for (let ionContent of ionContents) {
    ionContent.scrollToTop(500);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet)),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (shouldDisplaySplashscreen.value)
            ? (_openBlock(), _createBlock(SplashScreen, {
                key: 0,
                onDismissRequest: hideSplashscreen
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})